import React, { useEffect } from 'react'
import { AddAgreementPageProps } from './AddAgreementPage.types'
// import styles from './AddAgreementPage.module.scss'
// import cl from 'classnames'
import { AgreementPage } from '../AgreementPage'
import { inject } from 'mobx-react'
import { AGREEMENT_PAGE_STORE } from 'store'

const AddAgreementPageComponent = (props: AddAgreementPageProps) => {
  const {
    [AGREEMENT_PAGE_STORE]: {
      startNewAgreement,
      createAgreement
    }
  } = props

  useEffect(startNewAgreement, [startNewAgreement])

  return (
    <AgreementPage
      onSubmit={createAgreement}
    />
  )
}

const AddAgreementPage = inject(AGREEMENT_PAGE_STORE)(AddAgreementPageComponent)
export { AddAgreementPage }
